import TeamTableHelper from "./team-table-helper";

const TeamHelpers = {
  TableMain: TeamTableHelper,
};

export default TeamHelpers;
